import React from 'react';
import Image from 'next/image';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import useWindowSize from '@/hooks/useWindowSize';
import { PensionPage, PetPage, SelectedIns } from '@/recoil/plan';
import { IETCCard, ETCGuaranteeItems, TMINTRO } from '@/models/plan/main';
import { TInsuranceToString, TInsuranceType } from '@/models/plan';
import { defaultSize } from '@/models/breakPoints';
import { FontStyle } from '@/utils/StyleUtil';

const EtcGuaranteeMenu = () => {
    const { width } = useWindowSize();
    const router = useRouter();
    const setInsuranceType = useSetRecoilState(SelectedIns);
    const setPensionPageVisited = useSetRecoilState(PensionPage);
    const setPetPageVisited = useSetRecoilState(PetPage);
    setPensionPageVisited(false);
    setPetPageVisited(false);

    const showIntroPageDefaults = { TM: true, TMFETUS: true, TMSICK: true, IM: true, DE: true, DM: true };
    const showIntroPageString = localStorage.getItem('showIntroPage');
    const showIntroPage =
        showIntroPageString !== null
            ? { ...showIntroPageDefaults, ...JSON.parse(showIntroPageString) }
            : showIntroPageDefaults;

    const handleClick = (code: TInsuranceType) => {
        setInsuranceType(code);
        const insString = TInsuranceToString(code);
        if (TMINTRO[insString] && showIntroPage[insString]) {
            router.push(`/tm-intro?ins=${insString}`, '/tm-intro');
        } else {
            router.push('/plan/user-info');
        }
    };

    const insuranceCard = ({ prefixLabel, suffixLabel, image, code }: IETCCard) => {
        return (
            <Container onClick={() => handleClick(code)} inquiry={false}>
                <ImageContainer>
                    <Image src={image} alt={prefixLabel} width="50px" height="46px" />
                </ImageContainer>
                <TextContainer>
                    <div className="prefix_text">{prefixLabel}</div>
                    <h2 className="suffix_text">
                        {width >= defaultSize ? suffixLabel.default : suffixLabel?.small ?? suffixLabel.default}
                    </h2>
                </TextContainer>
            </Container>
        );
    };

    return (
        <EtcContainer>
            {insuranceCard(ETCGuaranteeItems[0])}
            {insuranceCard(ETCGuaranteeItems[1])}
            {insuranceCard(ETCGuaranteeItems[2])}
            <div style={{ height: '30px' }} />
        </EtcContainer>
    );
};

const EtcContainer = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    padding: 2px 20px 0 20px;
    gap: 10px;
    .prefix_text {
        margin: 0;
        ${FontStyle(18, 26, '700', '#111111', -1)};
    }
    .suffix_text {
        margin: 4px 0 0 0;
        ${FontStyle(12, 20, '400', '#ACACAC', -1)};
    }
`;

const Container = styled.div<{ inquiry: boolean }>`
    border-radius: 10px;
    background-color: #fff;
    background-color: ${({ inquiry }) => (inquiry ? '#F6FCFD' : '#FFF')};
    display: flex;
    gap: 20px;
    padding: 20px;
    padding-right: 0px;
    ${({ inquiry }) => inquiry && { border: `2px solid #0EC4CF` }};
`;

const ImageContainer = styled.div``;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export default EtcGuaranteeMenu;
